import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/save-win/side_img.webp";

function Plateform() {
  return (
    <section
      className="save_platform p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto order-md-1 order-2"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/save-win/tek_img_03.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={593}
                height={650}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={6}
            className="offset-xl-1 my-auto order-md-2 order-1"
          >
            <h2>
              App
              <span style={{ color: "#198463" }}> Features</span>
            </h2>
            <p>
              This price comparison app features an intuitive interface to track
              user spending and savings and allows users to redeem rewards they
              have earned. Besides, the app also offers discounts, promotions,
              and prizes to incentivize users to save more.
            </p>
            <p>
              Moreover, it also offers the ability to earn points, cashback, and
              other rewards through loyalty programs, referrals, and by
              externally sharing the app. Furthermore, it also features website
              links for redirecting, so that the users can search, filter, sort,
              and purchase their favorite products.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Plateform;
